module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shorts-83da4e716fe2f9bb8cd4be2ec75f3cfd.svg";